import React, { useState } from "react";
import { BaseModal } from "./BaseModal";
import { TextArea } from "./InputGroup";

interface NoteModalProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  leftOffset?: number;
  onNoteAdded: (activity: { icon: string; time: string; text: string }) => void;
}

const NoteModal: React.FC<NoteModalProps> = ({
  open,
  onClose,
  onOpen,
  leftOffset = 50,
  onNoteAdded,
}) => {
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  const handleAddNote = () => {
    if (!note.trim()) {
      setError("Bitte eine Notiz eingeben.");
      return;
    }
    const currentTime = new Date().toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const newActivity = {
      icon: "fa-solid fa-sticky-note",
      time: currentTime,
      text: `Notiz hinzugefügt: ${note}`,
    };
    onNoteAdded(newActivity);
    setNote("");
    setError("");
    onClose();
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      leftOffset={leftOffset}
      headerText="Notiz erstellen"
      className="note-modal"
    >
      <TextArea
        label="Notiz:"
        value={note}
        onChange={setNote}
        placeholder="Notiz eingeben..."
        error={error}
      />

      <div className="modal-actions">
        <button onClick={handleAddNote} className="primary-button">
          Notiz hinzufügen
        </button>
      </div>
    </BaseModal>
  );
};

export default NoteModal;
